<template>
    <div class="app-main" id="sysInfoPage">
        <el-row type="flex" class="app-main-header" align="middle" v-if="pageFlag!='audit'">
            <!-- 页面title -->
			<el-col :span="6">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{ $route.meta.title }}</span>
                    <span style="margin-left:10px">
                        <el-tag v-if="status == 0 && !gysInfo.QYXX" type="info">未保存</el-tag>
                        <el-tag v-if="status == 0 && gysInfo.QYXX" type="info">已保存</el-tag>
                        <el-tag v-if="status == 1" type="warning">待审批</el-tag>
                        <el-tag v-if="status == 2" type="success">已通过</el-tag>
                        <el-tag v-if="status == 3" type="danger">已驳回</el-tag>
                    </span>
				</div>
			</el-col>
            <!-- 批量操作 -->
			<el-col :span="18" class="app-main-header-btns">
                <!-- <el-button type="primary" v-if="status == 2 && checkRole('gys_role')" @click="applyChange" size="small">申请变更信息</el-button> -->
                <!-- <el-button type="primary" v-if="(!gysInfo.QYXX || status == 0 || status ==2) && !showAuditList && (checkRole('gys_role')|| checkRole('gysWaitAudit'))" @click="goEditInfo" size="small">补充企业信息</el-button> -->
                <el-button type="primary" v-if="(status == 0 || status ==3) && !showAuditList && (checkRole('gys_role')|| checkRole('gysWaitAudit'))" @click="goEditInfo" size="small">补充企业信息</el-button>
                <el-button type="primary" v-if="status ==2 && !showAuditList && (checkRole('gys_role')|| checkRole('gysWaitAudit'))" @click="goChangeEditInfo" size="small">变更企业信息</el-button>
                <el-button type="primary" v-if="(gysInfo.QYXX && !showAuditList) && checkRole('gys_audit')" @click="goAuditInfo" size="small">审核详情</el-button>
                <!-- <el-button type="primary" @click="goEditInfo" size="small">补充企业信息</el-button> -->
                <!-- <el-button type="primary" v-if="!showAuditList && (checkRole('gys_role')|| checkRole('gysWaitAudit'))" :disabled="(!gysInfo.QYXX && (status == 0 || status == 3)) || status == 1 || status == 2" @click="submitAudit" size="small">提交审核</el-button> -->
                <el-button type="primary" v-if="!showAuditList && checkRole('gys_audit') && status == 1"  @click="auditOpen" size="small">审核</el-button>
                <el-button type="primary" v-if="pageFlag == 'showGysInfo' && !hide" @click="$router.back(-1)" size="small">返回</el-button>
            </el-col>
        </el-row>
        <div class="info-wrap">
            <div :class="['info-left',showAuditList?'has-audit-list':'']">
                    <div class="info-main" :style="{height:infoMainHeight}">
                        <!-- 企业信息 -->
                        <el-card class="box-card box-card-margin-bottom">
                            <ShowRegisterInfo :title="'企业信息'" :changeInfoId="changeInfoId" :form="gysInfo.QYXX"/>
                        </el-card>
                        <!-- 业务信息 -->
                        <el-card class="box-card box-card-margin-bottom">
                            <ShowYwInfo :title="'业务信息'" :changeInfoId="changeInfoId" :form="gysInfo.YWXX"/>
                        </el-card>
                        <!-- 供货类别 -->
                        <el-card class="box-card box-card-margin-bottom">
                            <ShowJyClassify  :title="'供货类别'" :changeInfoId="changeInfoId" :form="GHLBdata"/>
                        </el-card>
                        <!-- 联系人信息 -->
                        <el-card class="box-card box-card-margin-bottom">
                            <ShowLxrInfo :title="'联系人信息'" :changeInfoId="changeInfoId" :form="LXRXXdata"/>
                        </el-card>
                        <!-- 地址信息 -->
                        <el-card class="box-card box-card-margin-bottom">
                            <ShowAddress :title="'地址信息'" :changeInfoId="changeInfoId" :form="DZXXData"/>
                        </el-card>
                        <!-- 银行信息 -->
                        <el-card class="box-card box-card-margin-bottom">
                            <ShowBankInfo :title="'银行信息'" :changeInfoId="changeInfoId" :form="YHXXdata"/>
                        </el-card>
                        <!-- 开票信息 -->
                        <el-card class="box-card box-card-margin-bottom">
                            <ShowInvoiceInfo :title="'开票信息'" :changeInfoId="changeInfoId" :form="gysInfo.KPXX"/>
                        </el-card>
                        <!-- 开票信息 -->
                        <el-card class="box-card box-card-margin-bottom">
                            <ShowCwInfo :title="'财务信息'" :changeInfoId="changeInfoId" :form="CWXXdata"/>
                        </el-card>
                        <!-- 公司附件 -->
                        <el-card class="box-card box-card-margin-bottom">
                            <ShowFileInfo :title="'公司附件'" :changeInfoId="changeInfoId" :form="GSFJdata"/>
                        </el-card>
                    </div>

            </div>
            <div class="info-right" v-if="showAuditList">
                <el-card class="box-card">
                    <div class="info-main" :style="{height:infoMainHeight}">
                        <div style="padding-bottom: 5px;display: flex;align-items: center;">
                            <el-divider direction="vertical"></el-divider>
                            <span>审核记录</span>
                        </div>
                        <div class="audit-list-box">
                            <div class="audit-item" v-for="(item,index) in auditList" :key="index">
                                <div class="bar">
                                    <span class="time">{{item.createTime}}</span>
                                    <el-tag type="success" v-if="item.operDesc == '通过'">{{item.operDesc}}</el-tag>
                                    <el-tag type="danger" v-if="item.operDesc == '驳回'">{{item.operDesc}}</el-tag>
                                    <el-tag type="info" v-if="item.operDesc != '通过' &&  item.operDesc != '驳回'">{{item.operDesc}}</el-tag>
                                </div>
                                <div class="bh-reson" v-if="item.operDesc == '驳回'">{{item.remark}}</div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
        <AuditGys ref="AuditGysRef" @callback="AuditGysCallback" />
    </div>
</template>
<script>
import { supplierInfoById, submitAuditBasicInfo,supplierInfoBasicClassifyList,getByGysBasicId,getAuditListByRecordId,getSupplierApprovalMx,getDetailByRecordId,supplierApprovalRecordById } from '@/api/gys/supplierInfo.js';
import { supplierContactsList } from '@/api/gys/supplierContacts.js';
import { supplierAddressList } from '@/api/gys/supplierAddress.js'
import { supplierBankIdList } from '@/api/gys/supplierBankId.js'
import { supplierFinanceList } from '@/api/gys/supplierFinance.js'
import { supplierAttachList } from '@/api/gys/supplierAttach.js'
import ShowRegisterInfo from './ShowRegisterInfo';
import ShowYwInfo from './ShowYwInfo';
import ShowLxrInfo from './ShowLxrInfo';
import ShowJyClassify from './ShowJyClassify';
import ShowAddress from './ShowAddress';
import ShowBankInfo from './ShowBankInfo';
import ShowInvoiceInfo from './ShowInvoiceInfo';
import ShowCwInfo from './ShowCwInfo';
import ShowFileInfo from './ShowFileInfo';
import { gysInfoFilter } from '../../../utils/index'
import AuditGys from '../../gysmng/audit/AuditGys'
export default {
    props:['pageFlag','gysId','showAuditList'],
    data() {
        return {
            changeInfoId:null,  // 变更id
            hide:this.$route.query.hide,
            GYSId:'',
            basicId:null,
            status:-1,   // 0，草稿，1未审核，3驳回，2 审核通过
            gysInfo:{
                QYXX:null,
                YWXX:null,
                KPXX:null,
            },
            GHLBdata:[],    // 供货类别
            LXRXXdata:[],    // 联系人信息
            DZXXData:[],    // 地址信息
            YHXXdata:[],    // 银行信息
            CWXXdata:[],    // 财务信息
            GSFJdata:[],    // 公司附件
            auditList:[],   // 审核记录
            infoMainHeight:'100%',
            getGysInfoApi:null,
            showAuditBtn:false,
            ifChangeAudit:false,    // 是否变更审核
        };
    },
    components:{
        ShowRegisterInfo,ShowYwInfo,ShowLxrInfo,ShowAddress,ShowBankInfo,ShowInvoiceInfo,ShowJyClassify,ShowCwInfo,ShowFileInfo,AuditGys
    },
    computed: {
        userInfo:function(){
            return this.$store.getters['user/user'];
        },
    },
    created() {
        console.log(this.$route.query)
        console.log(this.showAuditList)
        if(this.$route.query.changeAudit){
            this.ifChangeAudit = true;
        }
        if(this.checkRole('gys_role') || this.checkRole('gysWaitAudit')){
            this.getGysInfoApic=getSupplierApprovalMx;
        }else{
            this.getGysInfoApic=getDetailByRecordId;
        }
        if(this.pageFlag){
            this.basicId = this.gysId;
            if(this.pageFlag == 'audit'){
                this.geGysInfo(this.gysId,'show')
                this.infoMainHeight = 'calc(100vh - 220px)'
            }
            if(this.pageFlag == 'showAuditInfo'){
                this.geGysInfo(this.gysId,'show')
                this.infoMainHeight = 'calc(100vh - 88px)'
            }
             if(this.pageFlag == 'showGysInfo'){
                this.geGysInfo(this.gysId,'show')
                this.infoMainHeight = 'calc(100vh - 145px)'
            }
        }else{
            this.geGysInfo();
            this.infoMainHeight = 'calc(100vh - 170px)'
        }


    },
    methods: {
        auditOpen(){
            this.$refs.AuditGysRef.auditOpen({id:this.gysId})
        },
        // 获取审核相关信息
        getAuditInfo(){
            // getByGysBasicId({supplierInfoId:this.basicId}).then(({data:res})=>{
            getAuditListByRecordId({id:this.basicId}).then(({data:res})=>{
                this.auditList = res.data || [];
                console.log(this.auditList)
            })
        },
        // 获取 企业信息、业务信息、开票信息
        async geGysInfo(id) {
            let _this = this;
            if(_this.checkRole('gys_role') || _this.checkRole('gysWaitAudit')){
                const { data: res } = await supplierInfoById({
                    id: id || null
                });
                _this.basicId = res.data.id;
                _this.status = res.data.status;
            }
            _this.getAuditInfo()    // 审核信息
            _this.getQYXX();
            _this.getYWXX();
            _this.getKPXX();
            _this.getGHLBdata();
            _this.getLXRXXdata();
            _this.getDZXXData();
            _this.getYHXXdata();
            _this.getCWXXdata();
            _this.getGSFJdata();
            console.log('审核状态')
            console.log(this.status)
        },
        // 获取企业信息
        getQYXX(){
            let _this = this;
            this.getGysInfoApic({
                classType:'com.srm.entity.SupplierInfo',
                classTypeIndex:'0',
                supplierInfoId:this.basicId,
                supplierApprovalRecordId:this.basicId,
            }).then(({data:res})=>{
                 if(this.checkRole('gys_audit')){
                    // this.showAuditBtn = true
                    this.status = res.data.recordStatus
                }
                if(res.data && res.data.jsonData){
                    let info = JSON.parse(res.data.jsonData);
                    this.gysInfo.QYXX = {
                       tyShXxCode:info.tyShXxCode,
                        name:info.name,
                        englishName:info.englishName,
                        qyShort:info.qyShort,
                        orgJgCode:info.orgJgCode,
                        dbsCode:info.dbsCode,
                        rzRegion:info.rzRegion,
                        qyTyoe:info.qyTyoe,
                        taxpayerSign:info.taxpayerSign,
                        country:info.country,
                        legalPerson:info.legalPerson,
                        zcCapital:info.zcCapital,
                        zcCurrency:info.zcCurrency,
                        foundDate:info.foundDate,
                        yyZzSrc:info.yyZzSrc,
                        manageArea:info.manageArea,
                        address:info.address,
                    }
                }
            })
        },
        // 获取业务新
        getYWXX(){
            let _this = this;
            this.getGysInfoApic({
                classType:'com.srm.entity.SupplierInfo',
                classTypeIndex:'1',
                supplierInfoId:this.basicId,
                supplierApprovalRecordId:this.basicId,
            }).then(({data:res})=>{
                if(res.data && res.data.jsonData){
                    let info = JSON.parse(res.data.jsonData);
                    this.gysInfo.YWXX = {
                        zySf:info.zySf,
                        jyXz:info.jyXz,
                        hyType:info.hyType,
                        shFwScope:info.shFwScope,
                        gsGw:info.gsGw,
                        gsLogoSrc:info.gsLogoSrc,
                        zyClass:info.zyClass,
                        gsDetail:info.gsDetail,
                    }
                }
            })
        },
         // 获取开票信息
        getKPXX(){
            let _this = this;
            this.getGysInfoApic({
                classType:'com.srm.entity.SupplierInfo',
                classTypeIndex:'2',
                supplierInfoId:this.basicId,
                supplierApprovalRecordId:this.basicId,
            }).then(({data:res})=>{
                if(res.data && res.data.jsonData){
                    let info = JSON.parse(res.data.jsonData);
                    this.gysInfo.KPXX = {
                        invoiceHead:info.invoiceHead,
                        swDjh:info.swDjh,
                        khhName:info.khhName,
                        khhNumber:info.khhNumber,
                        swDjDz:info.swDjDz,
                        swDjDh:info.swDjDh,
                        sprEmail:info.sprEmail,
                        sprDh:info.sprDh,
                    }
                }
            })
        },
        getTableData(type,index,callback){
            this.getGysInfoApic({
                classType:`com.srm.entity.${type}`,
                classTypeIndex:index,
                supplierInfoId:this.basicId,
                supplierApprovalRecordId:this.basicId,
            }).then(({data:res}) => {
                let tableData = [];
                if(res.data && res.data.jsonData){
                    tableData = JSON.parse(res.data.jsonData)
                }
                callback(tableData)
            })
        },
        // 获取供货类别 数据
        getGHLBdata(){
            this.getTableData('SupplierInfoBasicClassify','0',(datas)=>{
                this.GHLBdata = datas;
            })
        },
        async getLXRXXdata(){
            this.getTableData('SupplierContacts','0',(datas)=>{
                this.LXRXXdata = datas;
            })
        },
        async getDZXXData() {
            this.getTableData('SupplierAddress','0',(datas)=>{
                this.DZXXData = datas;
            })
        },
        async getYHXXdata(){
            this.getTableData('SupplierBankID','0',(datas)=>{
                this.YHXXdata = datas;
            })
        },
        async getCWXXdata(){
            this.getTableData('SupplierFinance','0',(datas)=>{
                this.CWXXdata = datas;
            })
        },
        async getGSFJdata(){
            this.getTableData('SupplierAttach','0',(datas)=>{
                this.GSFJdata = datas;
            })
        },
        goEditInfo(){
            // this.$router.push({path: '/gys/gysRegister'});
            this.$router.push({path: '/gysRegister/gysRegister'});
        },
        goChangeEditInfo(){
            this.$router.push({path: '/gysRegister/gysRegister'});
        },
        // 申请变更信息
        applyChange(){

        },
        // 查看审核详情
        goAuditInfo(){
            if(this.basicId){
                window.open(`/gys/showauditinfo/${this.basicId}`)
            }

        },
        // submitAudit(){
        //     let _this = this;
        //     _this.confirm({
        //         text: '是否确认提交审核',
        //         tip: '提示',
        //         type: 'info',
        //         fn: function(param) {
        //             submitAuditBasicInfo(param).then(({data:res})=>{
        //                 _this.$success('提交审核成功');
        //                 _this.geGysInfo();
        //             })
        //         },
        //         data: {
        //             id: this.basicId,
        //             status:1,
        //         } //参数对象 主要回调函数用
        //     });

        // },
        AuditGysCallback(obj){
            this.openDialog = false;
            this.geGysInfo(this.gysId,'show')
        },
    },
};
</script>

<style lang="scss">
    #sysInfoPage{
        .box-card-margin-bottom{
            margin-bottom: 15px;
        }
        .info-wrap{
            width: 100%;
            display: flex;
            justify-content: space-between;
            .info-main{
                flex: 1;
                width: 100%;
                padding: 0px 10px 0px 0;
                // height: calc(100vh - 170px);
                overflow-y: auto;
            }
        }
        .info-left{
            width: 100%;
            display: flex;
            &.has-audit-list{
                width: calc(100% - 300px);
            }
            .form-box{
                margin: 10px 0;
                .my-descriptions-label {
                    width:15%;
                }
                .my-descriptions-content{
                    width: 35%;
                }
            }
            .no-info-box{
                width: 100%;
                height: 100px;
                line-height: 100px;
                text-align: center;
                color: #999;
                font-size: 14px;
            }
        }
        .info-right{
            width: 290px;
            .audit-list-box{
                width: 100%;
                .audit-item{
                    margin-bottom: 10px;
                    .bar{
                        display: flex;
                        line-height: 28px;
                        justify-content: space-between;
                    }
                    .bh-reson{
                        width: calc(100% - 20px);
                        background: #eee;
                        text-align: justify;
                        padding: 10px;
                        margin: 10px 0;
                    }
                }
            }
        }
    }
</style>
